import { t } from "@/i18n-js/instance";
import { useFetchSpace } from "@circle-react/components/SettingsApp/Workflows/hooks/useFetchSpace";
import { hasEmoji } from "@circle-react/helpers/spaceHelpers";

interface SpaceFromIdProps {
  id: string;
}

export const SpaceFromId = ({ id }: SpaceFromIdProps) => {
  const { data: space, isLoading, isError } = useFetchSpace({ id });

  if (isLoading) {
    return (
      <span className="bg-tertiary block h-4 w-full animate-pulse rounded" />
    );
  }

  if (isError) {
    return (
      <div className="post__space">
        <span>{t("settings.workflows.history.errors.space.not_found")}</span>
      </div>
    );
  }

  return (
    <div className="post__space">
      {hasEmoji(space) && <span>{space?.emoji}</span>}
      <span>{space?.name}</span>
    </div>
  );
};
